import { render, staticRenderFns } from "./view2.vue?vue&type=template&id=07bbe736&scoped=true&"
import script from "./view2.vue?vue&type=script&lang=js&"
export * from "./view2.vue?vue&type=script&lang=js&"
import style0 from "./view2.vue?vue&type=style&index=0&id=07bbe736&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbe736",
  null
  
)

export default component.exports